// extracted by mini-css-extract-plugin
export default {"icon":"Info_icon__-V5CZ"};